import { render, staticRenderFns } from "./CountryPaymentCard.vue?vue&type=template&id=1be971e0&"
import script from "./CountryPaymentCard.vue?vue&type=script&lang=js&"
export * from "./CountryPaymentCard.vue?vue&type=script&lang=js&"
import style0 from "./CountryPaymentCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports